module.exports = __webpack_public_path__ + "resources/img/img-tmax-hyper-sql-for-postgre-sql-02-m.bda3989dbe4c6829c59a44bf14a3ef16.png";